module.exports = __webpack_public_path__ + "static/media/icon-png.5b1dc100.svg";